import { boolean, number, array, string, object } from '@gogame/schemas';
import * as schemas from '@gogame/schemas';

import {
  PREPAID_EXPENSE_TYPE,
  AFFILIATE,
  APPLICATION,
  NETWORK,
  PLATFORM,
  CAMPAIGNS,
  AMOUNT,
  CURRENCY,
  ADJUSTMENT_REASON,
  TYPE,
  COUNTRY,
} from 'scenes/SpendAdjustments/components/SpendAdjustmentForm/constants';

import { invoiceSchema } from './InvoicesFieldArray/schemas';
import {
  AFFILIATES,
  BUSINESS_PARTNER,
  EXPENSE_TYPE,
  IMPORTANCE_TYPE,
  INVOICES,
  PERIOD,
} from './constants';

export const spendAdjustmentsSchema = object({
  [PREPAID_EXPENSE_TYPE]: boolean().default(false),
  [PERIOD]: array().required('Period is required'),
  [AFFILIATE]: number().required('Affiliate is required'),
  [APPLICATION]: number().required('Application is required'),
  [NETWORK]: number().required('Network is required'),
  [PLATFORM]: number().required('Platform is required'),
  [CAMPAIGNS]: array(),
  [COUNTRY]: number().required('Country is required'),
  [AMOUNT]: number().required('Amount is required'),
  [CURRENCY]: string().required('Currency is required'),
});

export const spendAdjValidationSchema = spendAdjustmentsSchema.shape({
  [ADJUSTMENT_REASON]: number().required('Adjustment reason is required'),
  [TYPE]: number().required('Type is required'),
});

export const businessPartnerSchema = schemas
  .number()
  .required('Business partner is required');

export const affiliateSchema = schemas
  .array()
  .of(schemas.number())
  .when('$bpInvoiceLevel', (businessPartner, schema) => {
    return businessPartner
      ? schema.required('Affiliate  is required')
      : schema.notRequired();
  });
const expenseTypeSchema = schemas.number().required('Expense type is required');
const periodSchema = schemas.array().required('Period is required');
const invoicesSchema = schemas
  .array()
  .of(invoiceSchema)
  .required('At least 1 is required');

export const expenseTypeParamsSchema = schemas.object({
  [BUSINESS_PARTNER]: businessPartnerSchema,
  [AFFILIATES]: affiliateSchema,
});

export const periodParamsSchema = schemas.object({
  [BUSINESS_PARTNER]: businessPartnerSchema,
  [AFFILIATES]: affiliateSchema,
  [EXPENSE_TYPE]: expenseTypeSchema,
});

export const applicationParamsSchema = schemas.object({
  [BUSINESS_PARTNER]: businessPartnerSchema,
  [AFFILIATES]: affiliateSchema,
  [PERIOD]: periodSchema,
});

export const spendParamsSchema = schemas.object({
  [BUSINESS_PARTNER]: businessPartnerSchema,
  [AFFILIATES]: affiliateSchema,
  [PERIOD]: periodSchema,
});

export const invoicesParamsSchema = schemas.object({
  [BUSINESS_PARTNER]: businessPartnerSchema,
  [AFFILIATES]: affiliateSchema,
  [PERIOD]: periodSchema,
  [INVOICES]: invoicesSchema,
});

// no context params
export const financialResultSchema = schemas.object({
  [BUSINESS_PARTNER]: businessPartnerSchema,
  [PERIOD]: periodSchema,
  [EXPENSE_TYPE]: expenseTypeSchema,
  [INVOICES]: invoicesSchema,
  [IMPORTANCE_TYPE]: schemas.number().required('Importance type is required'),
});
